import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import {
  accountOpeningSteps,
  guardianInitialDetails,
  statesInNigeria,
  titles,
} from "../../utils/constants";
import Loader from "../Loader";
import CustomInputField from "../CustomInputField/CustomInputField";
import CustomDropdown from "../CustomDropdown";
import SectionLabel from "../SectionLabel";
import FormHelperText from "../FormHelperText";
import {
  extractValuesFromObj,
  isEmptyObj,
  returnInputErrorMessage,
  returnLgaError,
} from "../../utils/helpers";
import { guardianDetailsValidationSchema } from "../../utils/validationSchemas";
import apiHooks from "../../customHooks/apis";
import { GuardianDetailsPayload, State } from "../../models/IEnums.model";
import useAutoUpdateAddress from "../../customHooks/useAutoUpdateAddress";
type StateLgaType = Pick<
  GuardianDetailsPayload,
  "areaState" | "localGovernment"
>;
function UpdateGuardianDetails(props: any) {
  const dispatch = useDispatch();
  const {
    useGetRelationships,
    useGetBranchCodes,
    useGetSocialMediaTypes,
    useGetReligions,
    useGetCountries,
    useUserDetails,
    useGetAllCountriesAndStates,
  } = apiHooks;
  const {} = useGetRelationships();
  const { newCountriesArr: countries, getSelectedCountry } = useGetCountries();
  const { branches, getSelectedBranch } = useGetBranchCodes();
  const { socialMedia, getSocialMedia } = useGetSocialMediaTypes();
  const { religions, getSelectedReligion } = useGetReligions();
  const { userDetails, handleUpdateUserDetails } = useUserDetails();
  const { allCountries, getCountryStates } = useGetAllCountriesAndStates();
  const [otpLoader] = useState(false);
  const [genders] = useState<any[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);
  const [lgas, setLgas] = useState([]);
  const [residentialStateLga, setResidentialStateLga] = useState<StateLgaType>({
    areaState: "",
    localGovernment: "",
  });
  const goToStep = (step: any) => {
    handleUpdateUserDetails({
      ...formik.values,
      email: formik.values.emailAddress,
    });
    dispatch(setAccountOpeningStep(step));
  };

  const formik = useFormik<GuardianDetailsPayload>({
    initialValues: guardianInitialDetails,
    validationSchema: guardianDetailsValidationSchema,
    validateOnBlur: true,
    onSubmit: (values) => {
      handleUpdateUserDetails({
        ...values,
        gender: values?.gender?.[0] || "",
        country: +values.country,
        branchOfDomiciliation: +values.branchOfDomiciliation,
      });
      dispatch(setAccountOpeningStep(accountOpeningSteps.minorDetails));
    },
  });
  useAutoUpdateAddress<GuardianDetailsPayload>({
    formik,
    fieldNames: ["houseNumber", "streetName", "nearestBustopLandmark"],
    otherValues: [
      residentialStateLga.localGovernment,
      residentialStateLga.areaState,
    ],
  });
  // const handleBlurAddressChild = (
  //   event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  // ) => {
  //   const { name } = event.target;
  //   formik.setFieldValue(
  //     "address",
  //     `${formik.values?.houseNumber} ${formik.values?.streetName} ${formik.values?.nearestBustopLandmark} ${residentialStateLga.localGovernment} ${residentialStateLga.areaState}`.trim()
  //   );
  //   formik.setFieldTouched(name, true);
  // };

  const handleChangeStateLga = (name: keyof StateLgaType, value: string) =>
    setResidentialStateLga((prev) => ({ ...prev, [name]: value }));

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const selectedCountry = getSelectedCountry(`${formik.values.country}`);
  const states = formik.values.country
    ? selectedCountry !== "Nigeria"
      ? getCountryStates(selectedCountry)
      : statesInNigeria
    : [];

  useEffect(() => {
    const stateLga = userDetails?.address || "";
    if (stateLga) {
      const splitData = stateLga.split(" ");
      const state = splitData[splitData.length - 1];
      const lga = splitData[splitData.length - 2];
      setResidentialStateLga((prev) => ({
        ...prev,
        areaState: state,
        localGovernment: lga,
      }));
    }
    formik.setValues(
      {
        ...guardianInitialDetails,
        ...extractValuesFromObj(guardianInitialDetails, userDetails),
        emailAddress: userDetails.email || "",
        title: userDetails?.title || "",
        dob: userDetails?.dateOfBirth || "",
        areaState: userDetails?.state || "",
      },
      true
    );
  }, [userDetails, guardianInitialDetails, extractValuesFromObj]);

  useEffect(() => {
    // formik.setFieldValue(
    //   "address",
    //   `${formik.values?.houseNumber} ${formik.values?.streetName} ${formik.values?.nearestBustopLandmark} ${residentialStateLga.localGovernment} ${residentialStateLga.areaState}`.trim()
    // );
    setLgas(
      states.find(
        (state) =>
          state.name.toLowerCase() ===
          residentialStateLga.areaState
            ?.replace("State", "")
            ?.trim()
            ?.toLowerCase()
      )?.lgas || []
    );
  }, [residentialStateLga]);

  return (
    <div>
      {otpLoader && <Loader />}
      <div className=" card-form pl-1 pr-1 ">
        <form
          onSubmit={formik.handleSubmit}
          className="update-details-form-body"
        >
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-4">
              Update Guardian Details
            </h4>
            <p className="text-center pl-5 no-wrap">
              Hello{" "}
              <span className="font-weight-bold">
                <b>{userDetails.firstName},</b>{" "}
              </span>
              Welcome to The Alternative Bank
            </p>
            <FormHelperText />
            <div className="row">
              <div className="col mt-4 pt-2 sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6 sec">
                    <label htmlFor="firstname" className="label_text">
                      Guardian First name
                    </label>
                    <input
                      name="firstName"
                      value={userDetails?.firstName || ""}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Tunde"
                      disabled
                    />
                  </div>

                  <div className="col-lg-6">
                    <label htmlFor="secondname" className="label_text">
                      Guardian Middle name
                    </label>
                    <input
                      name="middleName"
                      value={userDetails?.middleName || ""}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder=""
                      disabled
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <label htmlFor="lastname" className="label_text">
                      Guardian Surname
                    </label>
                    <input
                      name="lastName"
                      value={userDetails?.lastName || ""}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Aminah"
                      disabled
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="dob" className="label_text">
                      Guardian Date of birth
                    </label>
                    <input
                      name="dob"
                      value={userDetails?.dateOfBirth || ""}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="12-04-1989"
                      id="dob"
                      disabled
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <CustomDropdown
                      label="Guardian State of Origin"
                      name="areaState"
                      value={formik.values.areaState || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6">
                    <CustomDropdown
                      label="Guardian LGA"
                      value={
                        userDetails?.lga || formik.values.localGovernment || ""
                      }
                      disabled={!!userDetails.lga}
                      required={!userDetails.lga}
                      options={
                        statesInNigeria.find((state) =>
                          state.name.includes(
                            formik.values.areaState.replace("State", "").trim()
                          )
                        )?.lgas
                      }
                      formik={formik}
                      onClickOption={formik.handleChange}
                      name="localGovernment"
                      errorMessage={
                        formik.touched.localGovernment &&
                        formik.errors.localGovernment &&
                        returnLgaError({
                          stateError: formik.errors.areaState,
                          lgaError: formik.errors.localGovernment,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <CustomDropdown
                      label="Title"
                      options={titles}
                      required={!userDetails?.title}
                      disabled={!!userDetails?.title}
                      onClickOption={formik.handleChange}
                      formik={formik}
                      name="title"
                      value={formik.values.title}
                      errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                        formik,
                        "title"
                      )}
                    />
                  </div>
                  <div className="col-lg-6">
                    <CustomInputField
                      label="Phone Number"
                      value={
                        userDetails?.phoneNumber || userDetails?.mobile || ""
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <label htmlFor="gender" className="label_text">
                      Guardian Gender
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <select
                      name="gender"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gender}
                      className="form-control border-dark"
                      style={{
                        padding: "13px",
                      }}
                      id="gender"
                      disabled
                    >
                      <option value="">
                        {formik.values.gender || "Select a gender"}
                      </option>
                      {genders.map((gender: any) => {
                        return (
                          <option key={gender.name} value={gender.value}>
                            {gender.name}
                          </option>
                        );
                      })}
                    </select>
                    {formik.touched.gender && formik.errors.gender ? (
                      <small className="text-danger">
                        {formik.errors.gender}
                      </small>
                    ) : null}
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="dateofbirth" className="label_text">
                      Email address
                    </label>
                    <input
                      name="emailAddress"
                      onChange={formik.handleChange}
                      value={formik.values.emailAddress}
                      onBlur={formik.handleBlur}
                      className="form-control bg-white border-dark"
                      placeholder=""
                      // disabled={
                      //   !!(userDetails.emailAddress || userDetails.email)
                      // }
                    />
                    {formik.touched.emailAddress &&
                    formik.errors.emailAddress ? (
                      <small className="text-danger">
                        {formik.errors.emailAddress}
                      </small>
                    ) : null}
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6"></div>
                  <div className="col-lg-6"></div>
                </div>
              </div>
            </div>

            <SectionLabel label="Other  Information" />

            <div className="col sec">
              <div className="row form-row mb-3">
                <CustomDropdown
                  required
                  extraClasses="col-lg-6 mt-2"
                  label="Guardian Religion"
                  name="religion"
                  labelKey="religion"
                  valueKey="id"
                  onClickOption={formik.handleChange}
                  value={getSelectedReligion(formik.values.religion as number)}
                  options={religions}
                  formik={formik}
                  errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                    formik,
                    "religion"
                  )}
                />
                <CustomDropdown
                  required
                  extraClasses="col-lg-6 mt-2"
                  label="Guardian Country"
                  name="country"
                  labelKey="lonG_DESC_ENG"
                  valueKey="countrY_CODE"
                  onClickOption={(e) => {
                    formik.handleChange(e);
                    setResidentialStateLga((prev) => ({
                      ...prev,
                      areaState: "",
                      localGovernment: "",
                    }));
                  }}
                  value={getSelectedCountry(`${formik.values.country}`)}
                  options={countries}
                  formik={formik}
                  errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                    formik,
                    "country"
                  )}
                />
              </div>

              <div className="row form-row mb-3">
                <CustomInputField
                  label="Guardian Maiden Name (Enter if Female)"
                  value={formik.values.maidenName}
                  name="maidenName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                    formik,
                    "maidenName"
                  )}
                />
              </div>

              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number<span className="text-danger">*</span>
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*"
                  />
                  {formik.touched.houseNumber && formik.errors.houseNumber ? (
                    <small className="text-danger">
                      {formik.errors.houseNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name <span className="text-danger">*</span>
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                  {formik.touched.streetName && formik.errors.streetName ? (
                    <small className="text-danger">
                      {formik.errors.streetName}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Nearest bus-stop/landmark"
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                    errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                      formik,
                      "nearestBustopLandmark"
                    )}
                  />
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="State"
                    required={!residentialStateLga.areaState || !!lgas.length}
                    name="areaState"
                    value={residentialStateLga.areaState}
                    onClickOption={(e) => {
                      handleChangeStateLga("areaState", e.target.value);
                      handleChangeStateLga("localGovernment", "");
                    }}
                    placeholder="Select state"
                    options={states}
                    labelKey="name"
                    valueKey="name"
                    formik={formik}
                    errorMessage={
                      formik.touched.areaState && !residentialStateLga.areaState
                        ? "State of residence is required"
                        : ""
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="Local Government Area (L.G.A)"
                    required
                    name="localGovernment"
                    onClickOption={(e) =>
                      handleChangeStateLga("localGovernment", e.target.value)
                    }
                    // onBlur={handleBlurAddressChild}
                    value={residentialStateLga.localGovernment}
                    placeholder={"Select LGA"}
                    options={lgas}
                    formik={formik}
                    errorMessage={returnLgaError({
                      stateError:
                        formik.touched.localGovernment &&
                        !residentialStateLga.areaState
                          ? "State of residence is required"
                          : "",
                      lgaError:
                        formik.touched.localGovernment &&
                        !residentialStateLga.localGovernment
                          ? "LGA of residence is required"
                          : "",
                    })}
                  />
                </div>
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Town"
                    name="town"
                    onChange={formik.handleChange}
                    value={formik.values.town}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter your town"
                    errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                      formik,
                      "town"
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="form-group mb-4">
              <label htmlFor="address" className="label_text">
                Enter full address<span className="text-danger">*</span>
              </label>
              <input
                name="address"
                onChange={formik.handleChange}
                value={formik.values.address}
                onBlur={formik.handleBlur}
                className="form-control sec border-dark"
                type="text"
                id="address"
                placeholder="No 12 Bode Thomas Masha round about Lagos"
                readOnly
              />
              {formik.touched.address && formik.errors.address ? (
                <small className="text-danger">{formik.errors.address}</small>
              ) : null}
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="Social media type"
                    name="socialMediaId"
                    onChange={formik.handleChange}
                    value={getSocialMedia(
                      formik.values.socialMediaId as number
                    )}
                    className="form-control border-dark"
                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                    options={socialMedia}
                    placeholder="--Choose one--"
                    labelKey="name"
                    valueKey="id"
                    errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                      formik,
                      "socialMediaId"
                    )}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="socialMediaHandle" className="label_text">
                    Enter social media link/handle
                  </label>
                  <input
                    name="socialMediaHandle"
                    onChange={formik.handleChange}
                    value={formik.values.socialMediaHandle}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="@john_doe"
                  />
                  {formik.touched.socialMediaHandle &&
                  formik.errors.socialMediaHandle ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaHandle}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="row form-row mb-3 align-items-end">
              <CustomDropdown
                required
                extraClasses="col-lg-6"
                label="Branch of Domiciliation"
                placeholder="Select"
                name="branchOfDomiciliation"
                value={getSelectedBranch(
                  `${formik.values.branchOfDomiciliation}`
                )}
                formik={formik}
                options={branches}
                labelKey="branch"
                valueKey="brancH_CODE"
                errorMessage={returnInputErrorMessage<GuardianDetailsPayload>(
                  formik,
                  "branchOfDomiciliation"
                )}
                onClickOption={formik.handleChange}
              />
              <div className="form-group col-lg-6">
                <label htmlFor="refferalcode" className="label_text">
                  DAO/Referral code(optional)
                </label>
                <input
                  name="referralCode"
                  onChange={formik.handleChange}
                  value={formik.values.referralCode}
                  className="form-control border-dark"
                  type="text"
                  id="name"
                  placeholder="Enter referral code"
                />
              </div>
            </div>

            <div>
              <div className="d-flex justify-content-end mt-4">
                <button
                  onClick={() => {
                    goToStep(accountOpeningSteps.accountValidation);
                  }}
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-gold btn-filled-white"
                  type="button"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  className="btn btn-filled-red"
                  disabled={isEmptyObj(formik.touched) || !formik.isValid}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateGuardianDetails;
